import axios from 'axios';
import { configRefs } from '@utils/config';

async function getCoWorkersRequest(teacher) {
  var _a, _b;
  if (!teacher || teacher.role !== "teacher" || teacher.authenticationProvider === "ekey" || !teacher.institution) {
    return [];
  }
  const response = await axios.get(
    `${(_a = await configRefs.apis.gas.get()) == null ? void 0 : _a.replaceAll(
      "{{version}}",
      "v1"
    )}/api/v1/Unic/Institution/Employees/${encodeURIComponent(
      (_b = teacher.institution) == null ? void 0 : _b.id
    )}`
  );
  return response.data.map((item) => ({
    id: item.UserId,
    institutionId: item.InstitutionId,
    name: item.FirstName && item.LastName ? `${item.FirstName} ${item.LastName}` : item.Name,
    birthdate: item.Birthdate ?? void 0,
    function: item.Function ?? void 0,
    schoolComName: item.SchoolComName ?? void 0
  })).sort((a, b) => a.name.localeCompare(b.name, "da-DK", { numeric: true }));
}

export { getCoWorkersRequest };
//# sourceMappingURL=request.get-co-workers.js.map
